import React, { FunctionComponent, memo } from "react";

import { IProps } from "./tick.types";
import "./tick.scss";

/**
 * Display range information
 * @param props.count    Index position of the current item
 * @param props.format   Callback to format the tick value
 * @param props.tick     Slider tick for current item
 */
const Tick: FunctionComponent<IProps> = ({ children, tick, count, format = (tickValue) => tickValue }) => {
    const { value, percent } = tick;
    return (
        <>
            <div
                className="metric-slider__ticks__line"
                style={{
                    left: `${percent}%`,
                }}
            />
            <div
                className="metric-slider__ticks__value"
                style={{
                    marginLeft: `${-(100 / count) / 2}%`,
                    width: `${100 / count}%`,
                    left: `${percent}%`,
                }}
            >
                {typeof children !== "undefined" ? <>{children(value)}</> : <>{format(value)}</>}
            </div>
        </>
    );
};

export default memo(Tick);
